<div class="outer-container">
    <span class="currentStatusTitile"></span>
    <div class="console-container">
      <div class="input-wrapper">
        <div class="row">
        <p class="first-header">The call was unsuccessful. (Disconnected)</p>
        <p class="second-header">Please verify the call disposition and add notes if desired or try calling again.</p>
        </div>
        <div class="row">
            <div class="col-8 input-data mb-1">
              <div class="input-data">
                <label for="callDisposition">Call Disposition:<span class="star"> *</span></label>
                <select  [(ngModel)]="callDisposition" name="callDisposition" id="callDisposition"
                 >
                  <option value="0">Select One</option>
                  <option
                    *ngFor="let option of dispositions | orderBy: 'DisplayOrder'"
                    value="{{ option.value }}"
                  >
                    {{ option.label }}
                  </option>
                </select>
              </div>
              <div class="text-danger" *ngIf="invalidDisposition && callDisposition===0 ">
                <small>Please confirm that correct disposition has been selected.</small>
              </div>
              </div>
          </div>
          <div class="row">
            <div class="col-10 input-data">
              <div class="input-data">
                <label for="notes">Notes:</label>
                <textarea  class="form-control" [(ngModel)]="notes" name="notes" id="notes"></textarea>
              </div>
          </div>
      </div>
      <div class="row">
        <div class="btn-wrapper text-end mt-3 mb-3">
  
          <button class="main-btn ms-2" type="submit" value="Submit" (click)="submitCall()" >Submit Call</button>
         
        </div>
      </div>
     
    </div>
  </div>  
  